// Phase 84.M.86 — Inline warning hiển thị ở các bước nhạy cảm: Login Google,
// Payment, Upload, Livestream. Mục tiêu nhắc user mở Safari/Chrome NGAY tại
// bước đang có rủi ro cao bị fail trong webview.
//
// User choices 3a — hiện cảnh báo nhẹ inline ở các bước trên.
import { Warning, ArrowSquareOut } from "@phosphor-icons/react";
import { toast } from "sonner";
import { buildShareableUrl } from "../../lib/inAppBrowser";
import { useInAppBrowser } from "../../contexts/InAppBrowserContext";

const FLOW_MESSAGES = {
  "login-google": "Đăng nhập Google có thể bị chặn trong trình duyệt của ứng dụng.",
  payment: "Thanh toán & cổng QR có thể không hiển thị đúng trong in-app browser.",
  upload: "Upload ảnh có thể fail trong webview do hạn chế truy cập camera/album.",
  livestream: "Livestream YouTube có thể không phát được trong in-app browser.",
};

export default function InAppBrowserInlineWarning({ flow = "login-google", className = "" }) {
  const { inAppInfo } = useInAppBrowser();
  if (!inAppInfo?.isInApp || !inAppInfo?.isMobile) return null;

  const handleCopy = async () => {
    const url = buildShareableUrl(typeof window !== "undefined" ? window.location.href : "");
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Đã sao chép đường dẫn", { description: "Dán vào Safari/Chrome rồi tiếp tục." });
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        toast.success("Đã sao chép đường dẫn");
      } catch {
        toast.error("Không thể sao chép tự động.");
      }
    }
  };

  const msg = FLOW_MESSAGES[flow] || FLOW_MESSAGES["login-google"];

  return (
    <div
      className={`rounded-2xl border border-[#FF8A00]/40 bg-[#FF8A00]/10 p-3 flex items-start gap-2.5 ${className}`}
      data-testid={`inapp-inline-warning-${flow}`}
    >
      <Warning size={16} weight="fill" className="text-[#FF8A00] mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-[12px] font-black text-[#FF8A00]">
          Mở bằng Safari hoặc Chrome để tránh lỗi
        </div>
        <div className="text-[11.5px] text-white/65 leading-relaxed mt-0.5">{msg}</div>
        <button
          type="button"
          onClick={handleCopy}
          className="mt-2 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-[#FF8A00]/35 bg-[#FF8A00]/15 hover:bg-[#FF8A00]/25 text-[10.5px] font-black text-[#FF8A00] tracking-wider uppercase transition"
          data-testid={`inapp-inline-copy-${flow}`}
        >
          <ArrowSquareOut size={11} weight="bold" />
          Sao chép đường dẫn
        </button>
      </div>
    </div>
  );
}
